module.exports = __webpack_public_path__ + "media/src/images/balloons/HomeBanner-learntec-61c5951fdb5021622e19a56160173141.png";